import {Dispatch, FC, SetStateAction} from 'react'
import {Modal} from 'react-bootstrap'
import {KTSVG} from '../../../../../../../../_metronic/helpers'
import {InputText} from '../../../../../../components/UI/Input'
import {Button, ButtonWrapper} from '../../../../../../components/UI/Button'
import {saveLaundryGenerateBilling} from '../../../../services'
import {useForm, FormProvider} from 'react-hook-form'
import {ShowSnackBar} from '../../../../../../util/functions'
interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  detail?: any
}

const ModalSaveReport: FC<Props> = ({show, setShow, detail}) => {
  const methods = useForm<any>()
  const {
    handleSubmit,
    formState: {errors},
    register,
    setValue,
  } = methods

  const handleClose = () => {
    setShow(false)
    setValue('descripcion', '')
  }

  const onSubmit = async (data: any) => {
    const {fechaPeriodoInicio, fechaPeriodoFin} = detail

    if (data.descripcion !== '') {
      const dateIni = fechaPeriodoInicio || ''
      const [dayIni, monthIni, yearIni] = dateIni.split('/')
      const fechaPeriodoInicioFormat = fechaPeriodoInicio
        ? yearIni + '-' + monthIni + '-' + dayIni
        : ''
      const dateFin = fechaPeriodoFin || ''
      const [dayFin, monthFin, yearFin] = dateFin.split('/')
      const fechaPeriodoFinFormat = fechaPeriodoFin ? yearFin + '-' + monthFin + '-' + dayFin : ''
      try {
        let obj = {
          ...data,
          ...detail,
          fechaPeriodoInicioFormat,
          fechaPeriodoFinFormat,
        }
        const {data: response} = await saveLaundryGenerateBilling(obj)
        if (!response.error) {
          ShowSnackBar('Se guardó con éxito')
          handleClose()
        }
      } catch (error) {
        ShowSnackBar('Error interno', 'error')
      }
    }
  }
  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-md'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>Guardar Reporte de Facturación</h5>
          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <FormProvider {...methods}>
            <form>
              <div className='row'>
                <div className='col-sm-12 col-lg-6'>
                  <strong>Compañía:</strong>
                </div>
                <div className='col-sm-12 col-lg-6'>{detail.compania || '-'}</div>
                <div className='col-sm-12 col-lg-6'>
                  <strong> Cliente:</strong>
                </div>
                <div className='col-sm-12 col-lg-6'>{detail.cliente || '-'}</div>
                <div className='col-sm-12 col-lg-6'>
                  <strong> Site:</strong>
                </div>
                <div className='col-sm-12 col-lg-6'>{detail.site || '-'}</div>
                <div className='col-sm-12 col-lg-6'>
                  <strong> Tipo Responsable:</strong>
                </div>
                <div className='col-sm-12 col-lg-6'>{detail.tipoResponsable || '-'}</div>
                <div className='col-sm-12 col-lg-6'>
                  <strong> Responsable:</strong>
                </div>
                <div className='col-sm-12 col-lg-6'>{detail.responsable || '-'}</div>
                <div className='col-sm-12 col-lg-6'>
                  <strong> Tipo de servicio:</strong>
                </div>
                <div className='col-sm-12 col-lg-6'>{detail.tipoServicio || '-'}</div>
                <div className='col-sm-12 col-lg-6'>
                  <strong> Desde:</strong>
                </div>
                <div className='col-sm-12 col-lg-6'>{detail.fechaPeriodoInicio || '-'}</div>
                <div className='col-sm-12 col-lg-6'>
                  <strong> Hasta:</strong>
                </div>
                <div className='col-sm-12 col-lg-6'>{detail.fechaPeriodoFin || '-'}</div>
                <div className='col-sm-12 col-lg-6'>
                  <strong> Descripción:</strong>
                </div>
                <div className='col-sm-12 col-lg-6'>
                  <div className='sdx_form_input'>
                    <InputText
                      name='descripcion'
                      textPlaceholder='Escribe la descripción'
                      errors={errors}
                      register={register}
                    />
                  </div>
                </div>
              </div>
            </form>
          </FormProvider>
        </div>
        <div className='modal-footer'>
          <ButtonWrapper className='sdx-white-bg'>
            <Button label='Guardar' onClick={handleSubmit(onSubmit)} />
            <Button label='Cancelar' onClick={() => handleClose()} />
          </ButtonWrapper>
        </div>
      </div>
    </Modal>
  )
}

export {ModalSaveReport}
